import React from 'react'
import Tooltip from '../Tooltip/Tooltip'
import Icon, { IconProps } from '../Icon2/Icon'
import './Help.css'

export interface HelpProps {
    className?: string
    text: string | React.ReactNode
    type: 'primary' | 'secondary' | 'basic'
    alignment?: string
    tippyProps?: any
    children?: string | React.ReactNode
    testId?: string,
    iconProps?: Partial<IconProps>,
    iconName?: string
}

export const Help = (props: HelpProps) => {

    const { className, text, alignment = "right", type = "primary", tippyProps = {}, testId = "cs-help", iconProps, iconName = "Question", ...otherProps } = props
    const variantType = type === "basic" ? "basic" : type === "secondary" ? "light" : "dark"
    return (
        <span className={className} data-test-id={testId}>
            <Tooltip {...tippyProps} content={text} variantType={variantType} type={type} position={alignment}>
                <Icon icon={iconName} version="v2" size="small" className="Help" {...iconProps} {...otherProps}></Icon>
            </Tooltip>
        </span>
    )
}

export default Help
